function isElement(element: any): boolean {
    return element?.nodeType === 1;
}

// ----------------------------------------------------------------------------

export default isElement;
